// src/config/lifecycleExplanations.js

export const lifecycleExplanations = {
  'Open': 'Project created pending review and assignment',
  'Kickoff Completed': 'Kickoff meeting completed roles, scope, schedule and deliverables defined',
  'RFI In Circulation': 'Pending information from client for submittal - plans/information',
  'In Process': 'Submitted pending approval',
  'Under Construction': 'Construction started',
  'Closeout Pending': 'All approvals received and under construction with close out services starting (if applicable)',
  'Services Fulfilled': 'All deliverables provided',
  'N/A': 'None Specified',
  'Approved Pending Payment': 'Fee payment required for completion',
};
